// Resalta sobre la oración los caracteres que recibieron alguna etiqueta.
// `marks` = [{ start, end, label, role? }] en offsets de caracteres (los manda el
// backend en summary.marks). Las marcas pueden solaparse (una palabra que es origen
// de dos relaciones): el texto se parte en segmentos por cada borde y cada segmento
// lista todas las etiquetas que lo cubren (visible al pasar el mouse).

const TYPE_HIGHLIGHT = {
  pos:       'bg-blue-100 text-blue-900 ring-blue-300',
  features:  'bg-emerald-100 text-emerald-900 ring-emerald-300',
  relations: 'bg-amber-100 text-amber-900 ring-amber-300',
  ner:       'bg-violet-100 text-violet-900 ring-violet-300',
};

const ROLE_LABEL = { head: 'origen', child: 'destino' };

const markTitle = (m) => (m.role ? `${m.label} (${ROLE_LABEL[m.role] || m.role})` : m.label);

const buildSegments = (text, marks) => {
  const valid = (marks || [])
    .map((m) => ({ ...m, start: Math.max(0, m.start), end: Math.min(text.length, m.end) }))
    .filter((m) => m.end > m.start);
  const cuts = new Set([0, text.length]);
  valid.forEach((m) => { cuts.add(m.start); cuts.add(m.end); });
  const points = Array.from(cuts).sort((a, b) => a - b);
  const segments = [];
  for (let i = 0; i < points.length - 1; i++) {
    const s = points[i];
    const e = points[i + 1];
    const covering = valid.filter((m) => m.start <= s && m.end >= e);
    segments.push({ text: text.slice(s, e), marks: covering });
  }
  return segments;
};

const HighlightedSentence = ({ text, marks, atype, className = '' }) => {
  if (!text) return <span className="text-gray-400 italic">sin texto</span>;
  const hl = TYPE_HIGHLIGHT[atype] || 'bg-yellow-100 text-yellow-900 ring-yellow-300';
  const segments = buildSegments(text, marks);
  return (
    <span className={className}>
      {segments.map((seg, i) => (
        seg.marks.length === 0 || !seg.text.trim() ? (
          <span key={i}>{seg.text}</span>
        ) : (
          <mark
            key={i}
            title={Array.from(new Set(seg.marks.map(markTitle))).join(' · ')}
            className={`rounded-sm ring-1 ring-inset ${hl}`}
          >
            {seg.text}
          </mark>
        )
      ))}
    </span>
  );
};

export default HighlightedSentence;
